import { create } from "zustand";

export type CardVideoMiniPlayerKind = "file" | "youtube" | "shaka";

export type CardVideoMiniPlayerMeta = {
  title?: string;
  subtitle?: string;
  mediaUrl?: string;
  embedUrl?: string;
  posterUrl?: string;
  /** Resume position (seconds) when recreating media in the mini player. */
  startTime?: number;
};

export type CardVideoMiniPlayerState = {
  visible: boolean;
  kind: CardVideoMiniPlayerKind | null;
  title: string;
  subtitle: string;
  mediaUrl: string;
  embedUrl: string;
  posterUrl: string;
  startTime: number;
};

type CardVideoMiniPlayerActions = {
  show: (
    kind: CardVideoMiniPlayerKind,
    meta?: CardVideoMiniPlayerMeta,
  ) => void;
  hide: () => void;
};

const EMPTY: CardVideoMiniPlayerState = {
  visible: false,
  kind: null,
  title: "",
  subtitle: "",
  mediaUrl: "",
  embedUrl: "",
  posterUrl: "",
  startTime: 0,
};

export const useCardVideoMiniPlayerStore = create<
  CardVideoMiniPlayerState & CardVideoMiniPlayerActions
>((set) => ({
  ...EMPTY,
  show: (kind, meta) =>
    set({
      visible: true,
      kind,
      title: String(meta?.title ?? "").trim() || "Now playing",
      subtitle: String(meta?.subtitle ?? "").trim(),
      mediaUrl: String(meta?.mediaUrl ?? "").trim(),
      embedUrl: String(meta?.embedUrl ?? meta?.mediaUrl ?? "").trim(),
      posterUrl: String(meta?.posterUrl ?? "").trim(),
      startTime: Math.max(0, Number(meta?.startTime) || 0),
    }),
  hide: () => set(EMPTY),
}));
